import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Currency} from './currency';

@Injectable()
export class CurrencyService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('currencies?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('currencies/' + _id).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('currencies/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('currencies/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(currency: Currency) {
    return this.http.post('currencies', currency).map((response: Response) => response.json());
  }

  update(currency: Currency) {
    return this.http.put('currencies/' + currency.id, currency).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('currencies/' + _id);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/currencies/currency.service.ts